import React from 'react';
import { ThankYouHeader } from '../../molecules/thank-you-header/thank-you-header.molecule';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { ThankYouFooter } from '../../molecules/thank-you-footer/thank-you-footer.molecule';
import { PaymentDeclinedBody } from '../../organisms/payment-declined-body/payment-declined-body.organism';

type Props = {
  onRetry: () => void;
};

export const CompraRecusada: React.FC<Props> = ({ onRetry }) => {
  return (
    <ThankYouContainer
      padding="2rem"
      margin="0 auto"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f7f9fc',
      }}
    >
      <ThankYouHeader />
      <ThankYouContainer
        padding="2rem 0"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <PaymentDeclinedBody onRetry={onRetry} />
      </ThankYouContainer>
      <ThankYouFooter />
    </ThankYouContainer>
  );
};
